import crypt from 'crypto-js';

export const util = {
    
///////////////////////////////////////////////// strings,number
    SN(str='') {
        let num=str.replace('.', '');
        num=str.replace(',', '.');
        return Number(num);
    },
    NS(str='') {
        let num=str.replace('.', '');
        num=str.replace(',', '.');
        return Number(num);
    },
//////////// date
    DS(fh='') {
        let p = fh.split(/\D/g)
        return [p[2],p[1],p[0] ].join("-")
    },


    

    round(val=0,dec=100) {       
        return Math.round(val * dec) / dec;
    },

//////////////////////////////////////////////// arrrays    
    array_object(arr) {
        let obj = [...arr.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
        return obj;
    },
    array_valores(arr, prop) {
        var A=arr;
        if (typeof(arr)==='object') { // pasamos a array
            A=this.object_array(arr);
        }
        return A.map(function(e) { return e[prop]; }).filter(function(e,i,a){
            return i === a.indexOf(e);
        }).sort();
      },
      object_array(obj) {
          let result=Object.keys(obj).map(function(key) {
              return obj[key];
          });
          return result;
    },

//////////////////////////////////////////////////////////////////
    validaCIF(nif) {
        nif = nif.toUpperCase().replace(/[_\W\s]+/g, '');
        if(/^(\d|[XYZ])\d{7}[A-Z]$/.test(nif)) {
            let num = nif.match(/\d+/);
            num = (nif[0]!='Z'? nif[0]!='Y'? 0: 1: 2)+num;
            if(nif[8]=='TRWAGMYFPDXBNJZSQVHLCKE'[num%23]) {
                return /^\d/.test(nif)? 'DNI': 'NIE';
            }
        }
        else if(/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[\dA-J]$/.test(nif)) {
            var par = 0; 
            var non = 0;
            //letras = "ABCDEFGHKLMNPQS";
            //let = nif.charAt(0);
                    
            for (let zz=2;zz<8;zz+=2) {
                par = par+parseInt(nif.charAt(zz));
            }                
            for (let zz=1;zz<9;zz+=2) {
                let nn = 2*parseInt(nif.charAt(zz));
                if (nn > 9) nn = 1+(nn-10);
                non = non+nn;
            }    
            let parcial = par + non;
            let control = (10 - ( parcial % 10));
            if (control==10) control=0;
                
            if (control!=nif.charAt(8)) {
                //alert("El Cif no es válido");
                return false;
            }
            //alert("El Cif es válido");
            return true;
/* 
            var even_sum = 0;
            var odd_sum = 0;
            var n;

            for (let i=1;i<8;++i) {
                //let num = nif[i]<<i%2;
                //sum += parseInt(num / 10) + num % 10
                n = parseInt( nif[i], 10 );
                if ( i % 2 === 0 ) {
                  n *= 2;
                  odd_sum += n < 10 ? n : n - 9;
                } else {
                  even_sum += n;
                }
            }
            var c = (10 - (even_sum + odd_sum).toString().substr(-1) );
            if( ((/[KLMNPQRSW]/.test(nif[0]) || (nif[1]+nif[2])=='00') && nif[8]=='JABCDEFGHI'[c]) ||
                (/[ABEH]/.test(nif[0]) && nif[8]==c) ||
                (/[CDFGJUV]/.test(nif[0]) && (nif[8]=='JABCDEFGHI'[c] || nif[8]==c)) ) {
                return /^[KLM]/.test(nif)? 'ESP': 'CIF';
            }
 */        
        }
        return false;
    },

    // codificamos texto
    // codifica: atob + reverse
    // decodifi: reverse + btoa + reverse 
    codificaTexto(txt, tp=1, hash='abakanianos ') {
        let val='';        

        //codificamos texto
        if (tp==1) {
            val=hash+txt;   alert(val);            
            val=decodeURIComponent(escape(atob(val)));            
            //val=val.split("").reverse().join("");             
        }
        //decodificamos
        if (tp==2) {
            val=txt;
            //val=txt.split("").reverse().join(""); 
            val=btoa(unescape(encodeURIComponent(val)));            
            //val=val.substr(11);
        }
        console.log('*codificaTexto', val, hash);

        return val;            
    },

    //usa vue-cryptojs
    //tp->encriptar=1, desencriptar=0 
    encriptar(txt, tp=1, secret="Nakaba0092.") {        
        
        let val='';

        val= (tp==0
            ? crypt.AES.decrypt(txt, secret).toString(crypt.enc.Utf8)
            //? crypt.AES.decrypt(txt, secret)
            //: crypt.AES.encrypt(txt, secret).toString()
            : crypt.AES.encrypt(txt, secret)
        );
        console.log("*encriptar",txt, tp,  val);
        
        return val;
    },
    

    ///////////////////////////////////////////////////////////////////////////    encriptar
    encode64(text) {

        /* if (/([^\u0000-\u00ff])/.test(text)) {
            throw new Error("Can't base64 encode non-ASCII characters.");
        } */
    
        var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
            i = 0,
            cur, prev, byteNum, result = [];
    
        while (i < text.length) {
    
            cur = text.charCodeAt(i);
            byteNum = i % 3;
    
            switch (byteNum) {
            case 0:
                //first byte
                result.push(digits.charAt(cur >> 2));
                break;
    
            case 1:
                //second byte
                result.push(digits.charAt((prev & 3) << 4 | (cur >> 4)));
                break;
    
            case 2:
                //third byte
                result.push(digits.charAt((prev & 0x0f) << 2 | (cur >> 6)));
                result.push(digits.charAt(cur & 0x3f));
                break;
            }
    
            prev = cur;
            i++;
        }
    
        if (byteNum == 0) {
            result.push(digits.charAt((prev & 3) << 4));
            result.push("==");
        } else if (byteNum == 1) {
            result.push(digits.charAt((prev & 0x0f) << 2));
            result.push("=");
        }
    
        return result.join("");
    },
        
    decode64(text) {
    
        text = text.replace(/\s/g, "");
    
        if (!(/^[a-z0-9+/\s]+={0,2}$/i.test(text)) || text.length % 4 > 0) {
            throw new Error("Not a base64-encoded string.");
        }
        var digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
            cur, prev, digitNum, i = 0,
            result = [];
    
        text = text.replace(/=/g, "");
    
        while (i < text.length) {
    
            cur = digits.indexOf(text.charAt(i));
            digitNum = i % 4;
    
            switch (digitNum) {
    
                //case 0: first digit - do nothing, not enough info to work with
            case 1:
                //second digit
                result.push(String.fromCharCode(prev << 2 | cur >> 4));
                break;
    
            case 2:
                //third digit
                result.push(String.fromCharCode((prev & 0x0f) << 4 | cur >> 2));
                break;
    
            case 3:
                //fourth digit
                result.push(String.fromCharCode((prev & 3) << 6 | cur));
                break;
            }
    
            prev = cur;
            i++;
        }
    
        return result.join("");
    },
    
    ord(string) {
    
        var str = string + '',
            code = str.charCodeAt(0);
        if (0xD800 <= code && code <= 0xDBFF) {
            var hi = code;
            if (str.length === 1) {
                return code;
            }
            var low = str.charCodeAt(1);
            return ((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000;
        }
        if (0xDC00 <= code && code <= 0xDFFF) {
            return code;
        }
        return code;
    },
    
    decrypt(sData, sKey) {
        var sResult = "";
        sData = this.decode64(sData);
        var i = 0;
        for (i = 0; i < sData.length; i++) {
            var sChar = sData.substr(i, 1);
            var sKeyChar = sKey.substr(i % sKey.length - 1, 1);
            sChar = Math.floor(this.ord(sChar) - this.ord(sKeyChar));
            sChar = String.fromCharCode(sChar);
            sResult = sResult + sChar;
        }
        return sResult;
    },
    
    encrypt(sData, sKey) {
        var sResult = "";
        var i = 0;
        for (i = 0; i < sData.length; i++) {
            var sChar = sData.substr(i, 1);
            var sKeyChar = sKey.substr(i % sKey.length - 1, 1);
            sChar = Math.floor(this.ord(sChar) + this.ord(sKeyChar));
            sChar = String.fromCharCode(sChar);
            sResult = sResult + sChar;
        }
        return this.encode64(sResult);
    }
    
    
    // DOCUMENTATION
    
    //To Decrypt a string
    //
    // decrypt(Encrypted_String, Password); 
    //
    // Output: Decrypted String
    //
    // Example
    //
    //document.write(decrypt('qJzXqw==', 'mySuperSecretPassword'));
    
    // To Encrypt a string
    //
    // encrypt(String, Password);
    //
    // Output: Encrypted String
    //
    // Example
    //
    // document.write(encrypt('test','mySuperSecretPassword'));
    
}   